// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.path_root_TdlmF {
  position: relative;
  color: var(--line-color);
}

.path_children_SGj1E > .path_compact_Sg8j5:last-child {
  margin-left: -50px;
}

.path_header_jn52N {
  width: var(--left-width);
  border-right: var(--line-border);
  height: var(--line-radius);
  margin-top: calc(0px - var(--line-width));
}

.path_root_TdlmF ~ .path_root_TdlmF > .path_header_jn52N {
  width: var(--left-width);
  border-top: var(--line-border);
  border-top-right-radius: var(--line-radius);
}

.path_footer_Ik2EE {
  position: relative;
  height: 14px;
  margin-left: var(--left-width);
  margin-right: calc(var(--right-width) + var(--line-radius) + 2 * var(--line-width));
  border-bottom: var(--line-border);
  border-left: var(--line-border);
  border-bottom-left-radius: var(--line-radius);
}

.path_footer_Ik2EE::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: calc(0px - var(--line-width));
  left: calc(0px - var(--line-width));
  border-left: var(--line-border);
}

.path_children_SGj1E {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/routeDiagram/path.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,mFAAmF;EACnF,iCAAiC;EACjC,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,qCAAqC;EACrC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".root {\n  position: relative;\n  color: var(--line-color);\n}\n\n.children > .compact:last-child {\n  margin-left: -50px;\n}\n\n.header {\n  width: var(--left-width);\n  border-right: var(--line-border);\n  height: var(--line-radius);\n  margin-top: calc(0px - var(--line-width));\n}\n\n.root ~ .root > .header {\n  width: var(--left-width);\n  border-top: var(--line-border);\n  border-top-right-radius: var(--line-radius);\n}\n\n.footer {\n  position: relative;\n  height: 14px;\n  margin-left: var(--left-width);\n  margin-right: calc(var(--right-width) + var(--line-radius) + 2 * var(--line-width));\n  border-bottom: var(--line-border);\n  border-left: var(--line-border);\n  border-bottom-left-radius: var(--line-radius);\n}\n\n.footer::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: calc(0px - var(--line-width));\n  left: calc(0px - var(--line-width));\n  border-left: var(--line-border);\n}\n\n.children {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `path_root_TdlmF`,
	"children": `path_children_SGj1E`,
	"compact": `path_compact_Sg8j5`,
	"header": `path_header_jn52N`,
	"footer": `path_footer_Ik2EE`
};
module.exports = ___CSS_LOADER_EXPORT___;
